<template>
    <div class="toolbar-wrapper">
        <div class="toolbar-container">
            <div class="toolbar" ref="toolbar">
                <div class="toolbar-logo">
                    <slot name="logo">
                        <svg width="100%" height="100%" viewBox="0 0 100 50" preserveAspectRatio="xMidYMid meet">
                            <!-- Your SVG image -->
                        </svg>
                    </slot>
                </div>
                <div class="toolbar-items">
                    <div
                        v-for="(item, index) in visibleItems"
                        :key="item.id"
                        class="toolbar-item-container"
                        :style="{ minWidth: minWidth }"
                        ref="toolbarItems"
                    >
                        <div v-if="item.component" class="toolbar-component">
                            <component :is="item.component" @dropdown-opening="onDropdownOpening" />
                        </div>
                        <div v-else class="toolbar-item" @click="() => onItemClick(item, index, 'item')">
                            <div class="item-content" :class="{ 'vertical-layout': item.asset }">
                                <component
                                    v-if="item.asset"
                                    :is="item.asset"
                                    class="item-asset"
                                    @click="() => onItemClick(item)"
                                />
                                <span class="item-text" @click="() => onItemClick(item)">
                                    {{ item.text }}
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="activeDropdown === index && item.sub_menu?.length"
                            class="item-dropdown-content"
                            :style="getDropdownStyle(index)"
                        >
                            <div
                                v-for="(child, childIndex) in item.sub_menu"
                                :key="child.id"
                                class="dropdown-child-item"
                                @mouseenter="handleChildHover($event, child, 'main', index)"
                                @mouseleave="clearHoverTimeout"
                                :ref="el => setChildRef(el, index, childIndex)"
                                @click="() => onItemClick(child, childIndex, 'child')"
                            >
                                <div class="child-item-content">
                                    <component
                                        v-if="child.asset"
                                        :is="child.asset"
                                        class="child-asset"
                                        @click="() => onItemClick(child, childIndex, 'child')"
                                    />
                                    <span class="child-text">{{ child.text }}</span>
                                    <component v-if="child.sub_menu?.length" :is="arrowRight" class="item-asset" />
                                </div>
                                <div
                                    v-if="
                                        hoveredChild &&
                                        hoveredChild.id === child.id &&
                                        hoveredChild.type === 'main' &&
                                        child.sub_menu?.length
                                    "
                                    class="third-level-dropdown"
                                    :style="getThirdLevelStyle(childRefs[`child-${index}-${childIndex}`])"
                                >
                                    <div
                                        v-for="(grandChild, grandChildIndex) in child.sub_menu"
                                        :key="grandChild.id"
                                        class="dropdown-grandchild-item"
                                    >
                                        <div class="grandchild-item-content">
                                            <component
                                                v-if="grandChild.asset"
                                                :is="grandChild.asset"
                                                class="grandchild-asset"
                                                @click.stop="
                                                    () => onItemClick(grandChild, grandChildIndex, 'grandChild')
                                                "
                                            />
                                            <span
                                                class="grandchild-text"
                                                @click.stop="
                                                    () => onItemClick(grandChild, grandChildIndex, 'grandChild')
                                                "
                                                >{{ grandChild.text }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="dropdownItems.length > 0" class="dropdown">
                    <button @click.stop="toggleMenuDropdown" ref="dropdownButton">☰</button>
                    <div v-if="isMenuDropdownOpen" class="dropdown-content" :style="getMenuDropdownStyle()">
                        <div
                            v-for="(item, index) in dropdownItems"
                            :key="item.id"
                            class="dropdown-item-container"
                            @click.stop="item.component ? null : toggleHiddenItemDropdown(index)"
                        >
                            <div v-if="item.component" class="toolbar-component">
                                <component :is="item.component" />
                            </div>
                            <div v-else class="dropdown-item">
                                <div class="item-content" :class="{ 'horizontal-layout': item.asset }">
                                    <component
                                        v-if="item.asset"
                                        :is="item.asset"
                                        class="item-asset"
                                        @click="() => onItemClick(item, index, 'item')"
                                    />
                                    <span class="item-text" @click="() => onItemClick(item, index, 'item')">{{
                                        item.text
                                    }}</span>
                                </div>
                            </div>
                            <div
                                v-if="activeHiddenDropdown === index && item.sub_menu?.length"
                                class="item-dropdown-content hidden-item-dropdown"
                                :style="getHiddenDropdownStyle()"
                            >
                                <div
                                    v-for="(child, childIndex) in item.sub_menu"
                                    :key="child.id"
                                    class="dropdown-child-item"
                                    @mouseenter="handleChildHover($event, child, 'hidden', index)"
                                    @mouseleave="clearHoverTimeout"
                                    @click="() => onItemClick(child, childIndex, 'child')"
                                >
                                    <div class="child-item-content">
                                        <component
                                            v-if="child.asset"
                                            :is="child.asset"
                                            class="child-asset"
                                            @click="() => onItemClick(child, childIndex, 'child')"
                                        />
                                        <span class="child-text">{{ child.text }}</span>
                                    </div>
                                    <div
                                        v-if="
                                            hoveredChild &&
                                            hoveredChild.id === child.id &&
                                            hoveredChild.type === 'hidden' &&
                                            child.sub_menu &&
                                            child.sub_menu.length
                                        "
                                        class="third-level-dropdown"
                                        :style="getThirdLevelStyle(hoveredChild.element)"
                                    >
                                        <div
                                            v-for="(grandChild, grandChildIndex) in child.sub_menu"
                                            :key="grandChild.id"
                                            class="dropdown-grandchild-item"
                                        >
                                            <div class="grandchild-item-content">
                                                <component
                                                    v-if="grandChild.asset"
                                                    :is="grandChild.asset"
                                                    class="grandchild-asset"
                                                    @click="
                                                        () => onItemClick(grandChild, grandChildIndex, 'grandChild')
                                                    "
                                                />
                                                <span
                                                    class="grandchild-text"
                                                    @click="
                                                        () => onItemClick(grandChild, grandChildIndex, 'grandChild')
                                                    "
                                                    >{{ grandChild.text }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="toolbar-after">
                    <slot name="after"> </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, provide } from 'vue';
import {
    ddcCloseAllDropdown,
    ddcRemoveDropdownCloseFunc,
    ddcSetDropdownCloseFunc,
} from '@/components/app-controller-dropdown.js';
const emit = defineEmits(['item-click']);
const props = defineProps({
    items: {
        type: Array,
        default: () => [],
        required: true,
    },
    minWidth: {
        type: String,
        default: '80px',
    },
    arrowRight: {
        type: Object,
        default: null,
    },
});

const toolbar = ref(null);
const toolbarItems = ref([]);
const dropdownButton = ref(null);
const childRefs = ref({});

const allItems = ref([]);
const visibleItems = ref([]);
const dropdownItems = ref([]);
const isMenuDropdownOpen = ref(false);
const activeDropdown = ref(null);
const activeHiddenDropdown = ref(null);
const hoveredChild = ref(null);
const hoverTimeout = ref(null);
const resizeObserver = ref(null);

onMounted(() => {
    allItems.value = [...props.items];
    calculateVisibleItems();
    setupResizeObserver();
    window.addEventListener('click', closeAllDropdowns);
    ddcSetDropdownCloseFunc(closeAllDropdown);
    // closeAllDropdown
});

onBeforeUnmount(() => {
    if (resizeObserver.value) {
        resizeObserver.value.disconnect();
    }
    window.removeEventListener('click', closeAllDropdowns);
    clearHoverTimeout();
    ddcRemoveDropdownCloseFunc(closeAllDropdown);
});

const onItemClick = (item, index, itemType) => {
    if (item.sub_menu) {
        if (item.sub_menu.sub_menu?.length === 0) {
            emit('item-click', item);
            closeAllDropdown();
        } else {
            switch (itemType) {
                case 'item':
                    toggleItemDropdown(index);
                    break;
                default:
                    //toggleItemDropdown(index);
                    break;
            }
        }
    } else {
        emit('item-click', item);
        closeAllDropdown();
    }
};
const onDropdownOpening = () => {
    console.log('onDropdownOpening');
    // closeAllDropdown()
};

function closeAllDropdown() {
    activeDropdown.value = null;
    activeHiddenDropdown.value = null;
    //isMenuDropdownOpen.value = false
    hoveredChild.value = null;
}
const setChildRef = (el, index, childIndex) => {
    if (el) {
        childRefs.value[`child-${index}-${childIndex}`] = el;
    }
};

const calculateVisibleItems = () => {
    if (!toolbar.value) return;

    const toolbarEl = toolbar.value;
    const toolbarWidth = toolbarEl.offsetWidth;
    const dropdownButtonWidth = 50;
    const logoWidth = toolbarEl.querySelector('.toolbar-logo')?.offsetWidth || 0;

    const tempContainer = document.createElement('div');
    tempContainer.style.visibility = 'hidden';
    tempContainer.style.position = 'absolute';
    tempContainer.style.display = 'grid';
    tempContainer.style.gridAutoFlow = 'column';
    tempContainer.style.gap = '10px';
    document.body.appendChild(tempContainer);

    const items = allItems.value.map(item => {
        const element = document.createElement('div');
        if (item.component) {
            element.style.width = '300px'; // Fixed width for components
        } else {
            element.textContent = item.text;
            element.style.padding = '8px 16px';
            element.style.whiteSpace = 'nowrap';
        }
        tempContainer.appendChild(element);
        return { ...item, element, width: element.offsetWidth };
    });

    document.body.removeChild(tempContainer);

    let totalWidth = 0;
    const visible = [];
    const dropdown = [];

    for (const item of items) {
        if (totalWidth + item.width <= toolbarWidth - dropdownButtonWidth - logoWidth - 20) {
            visible.push(item);
            totalWidth += item.width + 10;
        } else {
            dropdown.push(item);
        }
    }

    visibleItems.value = visible;
    dropdownItems.value = dropdown;
};

const getDropdownStyle = index => {
    if (!toolbarItems.value || !toolbarItems.value[index]) return {};

    const item = toolbarItems.value[index];
    const rect = item.getBoundingClientRect();
    const menuItem = visibleItems.value[index];

    const dropdownWidth = calculateDropdownWidth(menuItem, rect.width);
    const windowWidth = window.innerWidth;
    const overflowRight = rect.left + dropdownWidth - windowWidth;

    let leftPosition = 0;
    if (overflowRight > 0) {
        leftPosition = -Math.min(overflowRight, rect.left);
    }
    const minWidth = 350;
    return {
        left: `${leftPosition}px`,
        top: '100%',
        minWidth: minWidth > rect.width ? `${minWidth}px` : `${rect.width}px`,
        width: minWidth > dropdownWidth ? `${minWidth}px` : `${dropdownWidth}px`,
        maxWidth: `${windowWidth - 10}px`,
    };
};

const calculateDropdownWidth = (menuItem, minWidth) => {
    let maxContentWidth = minWidth;
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.visibility = 'hidden';
    tempDiv.style.whiteSpace = 'nowrap';
    tempDiv.style.padding = '8px 16px';
    document.body.appendChild(tempDiv);

    if (menuItem.sub_menu?.length) {
        menuItem.sub_menu.forEach(child => {
            tempDiv.textContent = child.text;
            const childWidth = tempDiv.offsetWidth;
            const extraSpace = child.sub_menu?.length ? 30 : 0;
            maxContentWidth = Math.max(maxContentWidth, childWidth + extraSpace);
        });
    }

    document.body.removeChild(tempDiv);
    return Math.max(maxContentWidth + 32, minWidth);
};

const getThirdLevelStyle = childElement => {
    if (!childElement || !childElement.parentElement) {
        return { right: '100%', top: '0' };
    }

    const dropdownWidth = 200;
    const childRect = childElement.getBoundingClientRect();
    const windowWidth = window.innerWidth;

    if (childRect.right + dropdownWidth <= windowWidth) {
        return { left: '100%', top: '0', marginLeft: '5px' };
    }

    if (childRect.left - dropdownWidth >= 0) {
        return { right: '100%', top: '0', marginRight: '5px' };
    }

    return {
        right: '100%',
        top: '0',
        width: `${Math.min(dropdownWidth, windowWidth - 20)}px`,
        marginRight: '5px',
    };
};

const getMenuDropdownStyle = () => {
    if (!dropdownButton.value || dropdownItems.value.length === 0) return {};

    let maxWidth = 450;
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.visibility = 'hidden';
    tempDiv.style.whiteSpace = 'nowrap';
    tempDiv.style.padding = '8px 16px';
    document.body.appendChild(tempDiv);

    dropdownItems.value.forEach(item => {
        if (!item.component) {
            tempDiv.textContent = item.text;
            const itemWidth = tempDiv.offsetWidth;
            if (itemWidth > maxWidth) {
                maxWidth = itemWidth;
            }
            if (item.sub_menu && item.sub_menu.length) {
                item.sub_menu.forEach(child => {
                    tempDiv.textContent = child.text;
                    const childWidth = tempDiv.offsetWidth;
                    if (childWidth + 30 > maxWidth) {
                        maxWidth = childWidth + 30;
                    }
                });
            }
        }
    });

    document.body.removeChild(tempDiv);
    const totalWidth = maxWidth + 32;

    return {
        right: '0',
        top: '100%',
        minWidth: '150px',
        width: `${totalWidth}px`,
    };
};

const getHiddenDropdownStyle = () => {
    return {
        right: '100%',
        top: '0',
        minWidth: '150px',
        marginRight: '5px',
    };
};

const toggleMenuDropdown = () => {
    isMenuDropdownOpen.value = !isMenuDropdownOpen.value;
    activeDropdown.value = null;
    activeHiddenDropdown.value = null;
    hoveredChild.value = null;
};

const toggleItemDropdown = index => {
    const hasSubMenu = visibleItems.value[index]?.sub_menu?.length > 0;
    activeDropdown.value = hasSubMenu ? (activeDropdown.value === index ? null : index) : null;
    activeHiddenDropdown.value = null;
    isMenuDropdownOpen.value = false;
    hoveredChild.value = null;
    ddcCloseAllDropdown(closeAllDropdown);
};

const toggleHiddenItemDropdown = index => {
    const hasSubMenu = dropdownItems.value[index]?.sub_menu?.length > 0;
    activeHiddenDropdown.value = hasSubMenu ? (activeHiddenDropdown.value === index ? null : index) : null;
    activeDropdown.value = null;
    hoveredChild.value = null;
    ddcCloseAllDropdown(closeAllDropdown);
};

const handleChildHover = (event, child, type, parentIndex) => {
    clearHoverTimeout();

    if (!child.sub_menu || !child.sub_menu.length) {
        hoveredChild.value = null;
        return;
    }

    hoverTimeout.value = setTimeout(() => {
        hoveredChild.value = {
            id: child.id,
            type: type,
            parentIndex: parentIndex,
            element: event.currentTarget,
        };
    }, 200);
};

const clearHoverTimeout = () => {
    if (hoverTimeout.value) {
        clearTimeout(hoverTimeout.value);
        hoverTimeout.value = null;
    }
};

const closeAllDropdowns = event => {
    if (
        !event.target.closest('.toolbar-item-container') &&
        !event.target.closest('.dropdown-item-container') &&
        !event.target.closest('.dropdown button') &&
        !event.target.closest('.third-level-dropdown')
    ) {
        activeDropdown.value = null;
        activeHiddenDropdown.value = null;
        isMenuDropdownOpen.value = false;
        hoveredChild.value = null;
    }
};

const setupResizeObserver = () => {
    let resizeTimeout;
    resizeObserver.value = new ResizeObserver(() => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            calculateVisibleItems();
        }, 100); // Задержка в 100 мс
    });
    resizeObserver.value.observe(toolbar.value);
};

watch(
    () => props.items,
    newItems => {
        allItems.value = [...newItems];
        calculateVisibleItems();
    },
    { deep: true }
);
const closeAllPopupsFunctions = ref([]);
function setCloseAllPopupsFunction(func) {
    closeAllPopupsFunctions.value.push(func);
    console.log('setCloseAllPopupsFunction');
}
provide('setCloseAllPopupsFunction', setCloseAllPopupsFunction);
</script>

<style>
/* Keep the same styles as in your original component */
.toolbar-wrapper {
    position: relative;
    width: 100%;
}

.toolbar-container {
    width: 100%;
    overflow: visible;
}

.toolbar {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    width: 100%;
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    gap: 10px;
}

.toolbar-logo {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;
    padding-right: 10px;
}

.toolbar-logo svg {
    height: 100%;
    width: auto;
}

.toolbar-items {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 1px;
    overflow: visible;
    height: 100%;
}

.toolbar-item-container,
.dropdown-item-container {
    position: relative;
    height: 100%;
}
.toolbar-item-container:hover .toolbar-item {
    background-color: #f0f0f0;
}

.toolbar-item:hover {
    background-color: #f0f0f0;
}
.toolbar-item {
    border-right: lightgrey solid 1px;
    padding: 0 16px;
    justify-content: center;
}
.toolbar-item,
.dropdown-item {
    white-space: nowrap;
    background-color: #fff;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
}
.dropdown-item {
    padding: 7px 16px;
    border-bottom: lightgrey solid 1px;
}
.item-content {
    display: flex;
    align-items: center;
    gap: 8px;
}
.item-text {
    font-weight: 500;
    font-size: 14px;
}
.item-content.vertical-layout {
    flex-direction: column;
    gap: 4px;
}
.item-content.horizontal-layout {
    flex-direction: row;
    gap: 4px;
}
.child-item-content,
.grandchild-item-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.item-asset,
.child-asset,
.grandchild-asset {
    display: flex;
    align-items: center;
    justify-content: center;
}

.toolbar-component,
.dropdown-component {
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: auto;
}

.item-dropdown-content {
    position: absolute;
    background-color: white;
    border: 1px solid #ddd;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 100;
    padding: 10px;
}

.hidden-item-dropdown {
    position: absolute;
    background-color: white;
    border: 1px solid #ddd;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 100;
    padding: 10px;
}

.dropdown {
    position: relative;
}

.dropdown button {
    padding: 8px 16px;
    background-color: #e0e0e0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 100%;
}

.dropdown-content {
    position: absolute;
    background-color: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    z-index: 100;
    padding: 10px;
}

.dropdown-child-item {
    padding: 8px;
    cursor: pointer;
    white-space: nowrap;
    position: relative;
}

.dropdown-child-item:hover {
    background-color: #f0f0f0;
}

.third-level-dropdown {
    position: absolute;
    background-color: white;
    border: 1px solid #ddd;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 101;
    min-width: 150px;
    padding: 10px;
}

.third-level-dropdown[right='100%'] {
    margin-left: 0;
    margin-right: 5px;
}

.dropdown-grandchild-item {
    padding: 8px;
    cursor: pointer;
    white-space: nowrap;
}

.dropdown-grandchild-item:hover {
    background-color: #f0f0f0;
}
</style>
